// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"9a6bc345","513":"c561b777","703":"06b00923"}[chunkId] + ".chunk.js";
};